export default __webpack_public_path__ + "static/media/connectionOn.be0d7e05.svg";